import { render, staticRenderFns } from "./LongTermInitForm.vue?vue&type=template&id=3893c694&scoped=true&"
import script from "./LongTermInitForm.vue?vue&type=script&lang=js&"
export * from "./LongTermInitForm.vue?vue&type=script&lang=js&"
import style0 from "./LongTermInitForm.vue?vue&type=style&index=0&id=3893c694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3893c694",
  null
  
)

export default component.exports